export default __webpack_public_path__ + "static/media/jp.d288d548.svg";